/* eslint-disable */

const Logo = (props) => {
  const { size = 1 } = props

  const width = `${Math.ceil(141 * size)}`
  const height = `${Math.ceil(123 * size)}`
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 141 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="71.0618" cy="71" r="51" fill="#FADFDD" />
      <path
        d="M67.3993 60C67 60 66.5 56 66.5 56C66.5 56 39.5 50.5 57 30.0222C63.0001 23.5222 72.6083 26.1146 76.4366 30.0222C77.8219 31.4478 80.1632 37.0209 79.5306 38.8894L76.4364 51"
        fill="#010A0F"
      />
      <path
        d="M67.3993 60C67 60 66.5 56 66.5 56C66.5 56 39.5 50.5 57 30.0222C63.0001 23.5222 72.6083 26.1146 76.4366 30.0222C77.8219 31.4478 80.1632 37.0209 79.5306 38.8894L76.4364 51"
        stroke="#010A0F"
        strokeWidth="1.22"
        strokeMiterlimit="10"
      />
      <path
        d="M59.2859 42.5801C59.2776 42.6396 59.2566 42.6965 59.2244 42.7472C59.1922 42.7979 59.1495 42.8411 59.0992 42.8739C59.0489 42.9067 58.9921 42.9283 58.9327 42.9373C58.8733 42.9464 58.8126 42.9425 58.7548 42.9261C57.7389 42.6355 55.2498 42.2295 54.3216 44.9561C53.3934 47.6826 57.0231 49.2835 58.5516 49.8095C59.0015 49.9741 59.0992 50 59.0992 50C59.0992 50 59.5 51.5 60.5 53C61.5 54.5 63.5 56 65 56C68.5 59.5 60.5 74 60.5 74C60.5 74 76.0582 75.6175 81.4935 73.4768C81.4935 73.4768 73.7538 59.1195 74.0263 55.5533C74.0263 55.4749 80.6207 55.1981 80.6807 43.6597C80.7361 32.7902 72.6317 31.36 70.7845 31.2032C69.2237 31.0509 61.6272 29.6899 59.2859 42.5801Z"
        fill="#FFB9AE"
      />
      <path
        d="M80.9486 96.9827C79.143 95.3864 77.2035 93.6148 75.1069 91.6495L81.6321 79.456C80.436 77.0477 79.4478 74.9255 78.9583 73.583C78.6489 72.7248 88.3522 70.4815 88.5 70.5C91.2246 70.7722 97.9287 91.0405 100.653 93.6656C101.508 94.4868 102.907 93.7579 103.424 92.7429L118.866 61.8323C119.227 60.9465 123 55 131.5 50.5C134.811 53.1159 128.719 64.704 126.5 64.5C126.5 64.5 117.887 105.97 106.643 112.429C106.643 112.429 91.8238 114.117 82.4956 98.3714C81.572 99.0819 80.9625 99.5524 80.9625 99.5524C78.1778 98.0161 78.9675 97.3287 80.9486 96.9827Z"
        fill="#FFB9AE"
      />
      <path
        d="M50.6687 74.3902C50.6687 74.3902 55.9239 71.9912 60.2463 70.275C64.5225 67.3592 64.661 63.6361 64.661 63.6361C74.7327 62.4412 76.9308 63.5346 76.9308 63.5346C78.778 65.7306 89.5 71.5 89.5 71.5C89.2229 72.2335 90.2443 84.5261 91.6713 91.5894C93.0151 98.279 90 120.375 90 123L56.7644 121.951C56.7644 121.951 47.6994 83.3912 50.6687 74.3902Z"
        fill="white"
      />
      <path
        d="M55.7393 46.1602C55.7393 46.1602 56.2518 42.2987 59.4798 46.3401L55.7393 46.1602Z"
        fill="#DE5D49"
      />
      <path
        d="M65.4636 46.0879C65.9933 46.2246 66.4708 46.5149 66.8356 46.9223C67.2005 47.3297 67.4364 47.8359 67.5137 48.3771C67.591 48.9182 67.5062 49.4702 67.27 49.9632C67.0337 50.4563 66.6566 50.8685 66.1863 51.1477C65.7159 51.427 65.1732 51.5609 64.6268 51.5325C64.0804 51.5041 63.5546 51.3147 63.1157 50.9881C62.6769 50.6616 62.3447 50.2126 62.1609 49.6977C61.9772 49.1828 61.9501 48.625 62.0832 48.0948C62.1721 47.7406 62.3303 47.4075 62.5486 47.1147C62.7669 46.8218 63.0411 46.575 63.3553 46.3885C63.6695 46.2019 64.0175 46.0793 64.3794 46.0278C64.7412 45.9762 65.1097 45.9966 65.4636 46.0879Z"
        fill="#F58C7C"
      />
      <path
        d="M78.5001 45.0635C78.8825 45.1623 79.2271 45.372 79.4905 45.6664C79.7538 45.9607 79.9241 46.3265 79.9799 46.7175C80.0357 47.1085 79.9745 47.5073 79.804 47.8635C79.6335 48.2198 79.3613 48.5175 79.0217 48.7193C78.6822 48.9211 78.2905 49.0178 77.8961 48.9973C77.5017 48.9768 77.1221 48.8399 76.8054 48.604C76.4886 48.3681 76.2488 48.0437 76.1161 47.6716C75.9835 47.2996 75.964 46.8966 76.0601 46.5135C76.1242 46.2576 76.2384 46.0169 76.396 45.8054C76.5536 45.5938 76.7515 45.4155 76.9783 45.2807C77.2051 45.1459 77.4563 45.0573 77.7175 45.0201C77.9786 44.9828 78.2446 44.9976 78.5001 45.0635Z"
        fill="#F58C7C"
      />
      <path
        d="M71.1662 45L71 48.0911L72.5932 47.8604C72.6606 47.8507 72.7243 47.8237 72.778 47.782C72.8318 47.7403 72.8738 47.6853 72.8999 47.6225C72.9259 47.5597 72.9352 47.4912 72.9268 47.4237C72.9184 47.3562 72.8925 47.2921 72.8518 47.2376L71.1662 45Z"
        fill="#DC6856"
      />
      <path
        d="M65.1779 41.7206C64.6514 42.145 65.3903 40.3365 66.1338 40.1012C66.458 39.9673 66.8219 39.9662 67.1469 40.0983C67.4719 40.2304 67.7317 40.4851 67.8701 40.8071C66.8936 40.7887 65.9412 41.1118 65.1779 41.7206Z"
        fill="#010A0F"
      />
      <path
        d="M74.8887 39.018C74.1129 38.8981 73.1016 39.3917 73 40.0607C73.7217 39.8844 74.4765 39.8939 75.1935 40.0884"
        fill="#010A0F"
      />
      <path
        d="M67.0125 44.0357C67.0725 44.5755 67.3358 44.9907 67.599 44.9584C67.8622 44.9261 68.0238 44.4647 67.9638 43.925C67.9038 43.3852 67.6405 42.9654 67.3773 43.0023C67.1141 43.0392 66.9525 43.4913 67.0125 44.0357Z"
        fill="#010A0F"
      />
      <path
        d="M74.0131 42.9943C74.0685 43.511 74.3225 43.917 74.5718 43.8801C74.8212 43.8432 74.9782 43.4187 74.9228 42.8882C74.8674 42.3576 74.6134 41.9655 74.3594 42.0024C74.1054 42.0393 73.953 42.4914 74.0131 42.9943Z"
        fill="#010A0F"
      />
      <path
        d="M76.931 36.5964C76.931 36.5964 66.6515 37.2792 58.2607 40.2549C58.2607 40.2549 63.9962 13.801 76.931 36.5964Z"
        fill="#010A0F"
        stroke="#010A0F"
        strokeWidth="1.22"
        strokeMiterlimit="10"
      />
      <path
        d="M42.5 83.5C43.7 81.1 48.6667 75.8333 51 74C49.4 77.6 51.6667 95.5 53 103.5C53 106.5 49 114.5 39.5 114.5C34.401 114.5 29.924 112.989 25 101.5C23.5 98 16.5298 68.3162 14 68C6 67 4 61.5 3 59H12.5C15.5 60.3333 21.6 63.4 22 65C22.4 66.6 32 84 37 94.5C38.1667 90.5 41.3 85.9 42.5 83.5Z"
        fill="#FFB9AE"
      />
      <circle cx="96.5" cy="50.5" r="10.5" fill="#F36273"/>
      <path
        d="M94.2896 42.7632H98.7106L97.6053 53.2632H95.1185L94.2896 42.7632Z"
        fill="white"
      />
      <circle cx="96.5001" cy="56.5789" r="2.21053" fill="white"/>
      <path
        d="M141 17.3154L139.025 26.945L137.754 25.6982L135.592 27.2505L133.939 25.1849L130.231 27.8989L127.065 22.5645L123.532 24.6488L122.131 22.7017L117.645 25.2473L116.293 22.338L119.438 7L136.299 10.5057L141 17.3154Z"
        fill="#8DDCDD"
      />
      <path
        d="M136.299 10.5056L141 17.3154L135.152 16.0997L136.299 10.5056Z"
        fill="#31ADAE"
      />
      <path
        d="M138.604 28.8713L135.709 42.9999L113 38.2807L115.874 24.2622L117.224 27.1735L121.71 24.6279L123.111 26.573L126.646 24.4887L129.812 29.823L133.518 27.1091L135.171 29.1747L137.333 27.6224L138.604 28.8713Z"
        fill="#8DDCDD"
      />
      <path
        d="M13.1855 41.5893C13.1855 42.2992 12.9748 42.9932 12.58 43.5834C12.1852 44.1737 11.6241 44.6337 10.9676 44.9054C10.3111 45.1771 9.58876 45.2482 8.89183 45.1097C8.19491 44.9712 7.55474 44.6293 7.05229 44.1273C6.54984 43.6254 6.20766 42.9858 6.06904 42.2896C5.93041 41.5933 6.00155 40.8716 6.27348 40.2157C6.54541 39.5599 7.0059 38.9993 7.59672 38.6049C8.18754 38.2105 8.88216 38 9.59274 38C10.5456 38 11.4594 38.3782 12.1332 39.0513C12.807 39.7244 13.1855 40.6374 13.1855 41.5893V41.5893Z"
        stroke="#FFE2DF"
        strokeWidth="1.17"
        strokeMiterlimit="10"
      />
      <path
        d="M99.9719 18.9399C101.061 18.9399 101.944 18.058 101.944 16.97C101.944 15.882 101.061 15 99.9719 15C98.8828 15 98 15.882 98 16.97C98 18.058 98.8828 18.9399 99.9719 18.9399Z"
        fill="#FFE2DF"
      />
      <path
        d="M6 99C9.31369 99 12 96.3137 12 93C12 89.6863 9.31369 87 6 87C2.68631 87 0 89.6863 0 93C0 96.3137 2.68631 99 6 99Z"
        fill="#FFE2DF"
      />
      <path
        d="M34.2167 12.5049L28.6601 10L27.8867 11.6912C27.7725 11.9329 27.5943 12.139 27.3713 12.2876C27.1482 12.4361 26.8888 12.5214 26.6207 12.5343C26.3153 12.5443 26.0109 12.5737 25.7094 12.6226C25.4446 12.6617 25.1742 12.6285 24.927 12.5266C24.6797 12.4248 24.4649 12.258 24.3054 12.0441L23.2167 10.5294L18.2562 14.0686L19.3448 15.5833C19.4962 15.802 19.5854 16.0573 19.6027 16.3223C19.6201 16.5872 19.565 16.8519 19.4433 17.0882C19.3029 17.3578 19.1763 17.6343 19.064 17.9167C18.9665 18.1656 18.8025 18.3835 18.5899 18.5467C18.3772 18.7099 18.1239 18.8124 17.8571 18.8431L16 19.0245L16.5961 25.0686L18.4631 24.8824C18.7308 24.8611 18.9993 24.9128 19.2397 25.032C19.4802 25.1512 19.6834 25.3333 19.8276 25.5588C19.9064 25.6863 19.9901 25.8088 20.0788 25.9314C20.1675 26.0539 20.2562 26.1716 20.3498 26.2892C20.5197 26.495 20.6291 26.7437 20.6656 27.0077C20.7021 27.2716 20.6644 27.5404 20.5567 27.7843L19.7783 29.4902L25.3399 32L26.1133 30.299C26.2286 30.0575 26.4078 29.8519 26.6317 29.7042C26.8557 29.5565 27.1158 29.4724 27.3842 29.4608C27.6862 29.4484 27.9871 29.4189 28.2857 29.3726C28.5504 29.3334 28.8209 29.3666 29.0681 29.4685C29.3154 29.5703 29.5302 29.7371 29.6897 29.951L30.7783 31.4657L35.7438 27.9265L34.6552 26.4118C34.4991 26.1951 34.4071 25.9393 34.3897 25.6733C34.3723 25.4073 34.4301 25.1418 34.5567 24.9069C34.6939 24.6388 34.8172 24.3639 34.9261 24.0833C35.0208 23.8325 35.184 23.613 35.3972 23.4493C35.6104 23.2857 35.8652 23.1844 36.133 23.1569L38 22.9706L37.399 16.9265L35.532 17.1078C35.2659 17.1311 34.9986 17.0807 34.7595 16.9622C34.5204 16.8436 34.3189 16.6616 34.1773 16.4363C34.0936 16.3088 34.0099 16.1863 33.9212 16.0637C33.8325 15.9412 33.7438 15.8186 33.6502 15.7059C33.4814 15.4975 33.3729 15.2473 33.3364 14.9821C33.3 14.7169 33.3369 14.4468 33.4434 14.201L34.2167 12.5049ZM31.064 18.098C31.6401 18.898 31.9648 19.8499 31.9971 20.8335C32.0295 21.8171 31.7679 22.7882 31.2456 23.6239C30.7233 24.4596 29.9637 25.1223 29.0629 25.5284C28.162 25.9344 27.1603 26.0655 26.1846 25.9051C25.2089 25.7446 24.3029 25.2998 23.5812 24.627C22.8595 23.9541 22.3545 23.0834 22.1302 22.1249C21.9058 21.1664 21.9722 20.1633 22.3208 19.2423C22.6694 18.3214 23.2846 17.524 24.0887 16.951C25.1666 16.1828 26.507 15.8722 27.815 16.0873C29.1231 16.3024 30.2918 17.0256 31.064 18.098Z"
        fill="#8DDCDD"
      />
      <path
        d="M69.5 51.5001C69.5 51.5001 70.5 50.5001 71.5 50.0001C72.3553 49.5725 73 50.0001 73 50.0001"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.2282 12.1727L80.2406 22.7611L78.7282 14.2611L82.7283 12.1727L79.7341 2.07527L73.7283 2.76111L78.7282 10.2611L74.2282 12.1727Z"
        fill="#F36273"
      />
      <path
        d="M66.5883 15.3662L73.1693 21.2556L70.1646 15.7617L72.4318 13.4014L68.0393 7.1518L64.069 9.01159L69.24 13.0118L66.5883 15.3662Z"
        fill="#F36273"
      />
      <path
        d="M46.4999 31.5002C49.6999 27.1002 54.8332 28.6668 56.9999 30.0002V36.0001L53 46.0001C53.1667 49.0001 53.6 55.7001 54 58.5001C54.5 62.0001 46.4999 65.0001 42 64.5001C38.4001 64.1001 36.1667 59.0001 35.5 56.5001C36 57.1668 37.9 58.5001 41.5 58.5001C46 58.5001 44.4999 51.5001 43.4999 48.5001C42.4999 45.5001 42.4999 37.0002 46.4999 31.5002Z"
        fill="#010A0F"
        stroke="#010A0F"
      />
    </svg>
  )
}
/* eslint-enable */
export default Logo
